/** Mostly FE abstraction */
export enum PaymentProviderIdTypes {
  BridgeOnramp = 'bridge-onramp',
  BridgeOfframp = 'bridge-offramp',
  EasyPayOnramp = 'easy-pay-onramp',
  RedEnvelopeOnramp = 'red-envelope-onramp',
  EasyPayCrossChainTransfer = 'easy-pay-cross-chain-transfer',
  EasyPayOfframpTransfer = 'easy-pay-offramp-transfer',
}

export enum PaymentMethodTypes {
  EasyPay = 'easy_pay',
  RedEnvelope = 'red_envelope',
  Bridge = 'bridge',
}

export const paymentProviderIdMethodsMap: Record<
  PaymentProviderIdTypes,
  PaymentMethodTypes
> = {
  [PaymentProviderIdTypes.EasyPayOnramp]: PaymentMethodTypes.EasyPay,
  [PaymentProviderIdTypes.RedEnvelopeOnramp]: PaymentMethodTypes.RedEnvelope,
  [PaymentProviderIdTypes.BridgeOnramp]: PaymentMethodTypes.Bridge,
  [PaymentProviderIdTypes.BridgeOfframp]: PaymentMethodTypes.Bridge,
  [PaymentProviderIdTypes.EasyPayCrossChainTransfer]:
    PaymentMethodTypes.EasyPay,
  [PaymentProviderIdTypes.EasyPayOfframpTransfer]: PaymentMethodTypes.EasyPay,
};

export const onrampPaymentMethodIdMap: Record<
  PaymentMethodTypes,
  PaymentProviderIdTypes
> = {
  [PaymentMethodTypes.EasyPay]: PaymentProviderIdTypes.EasyPayOnramp,
  [PaymentMethodTypes.RedEnvelope]: PaymentProviderIdTypes.RedEnvelopeOnramp,
  [PaymentMethodTypes.Bridge]: PaymentProviderIdTypes.BridgeOnramp,
};

export const offrampPaymentMethodIdMap: Record<
  PaymentMethodTypes.EasyPay | PaymentMethodTypes.Bridge,
  PaymentProviderIdTypes
> = {
  [PaymentMethodTypes.EasyPay]: PaymentProviderIdTypes.EasyPayOfframpTransfer,
  [PaymentMethodTypes.Bridge]: PaymentProviderIdTypes.BridgeOfframp,
};
